import Swiper, { Navigation, FreeMode } from 'swiper'
import 'swiper/css/bundle'
import 'swiper/css/navigation';

class ProductSingleSlider {

  constructor(selector, id) {
    this.selector = selector;
    this.nav = {
      nextEl: '.js-'+id+'-swiper-next',
      nextLine: '.js-'+id+'-next-line',
      prevEl: '.js-'+id+'-swiper-prev',
      prevLine: '.js-'+id+'-prev-line',
      disabledEl: 'swiper-button-disabled'
    };
    this.init();
  }

  init() {
    const swiper = new Swiper(this.selector,
      {
        modules: [Navigation, FreeMode],
        //slidesPerView: 1.2,
        slidesPerView: 'auto',
        spaceBetween: 10,
        initialSlide: 0,
        speed: 500,
        navigation: this.nav,
        grabCursor: true,
        freeMode: true,
        setWrapperSize: true,
        breakpoints: {
          // when window width is >= px
          650: {
            //slidesPerView: 1.5,
            spaceBetween: 16,
          },
          900: {
            //slidesPerView: 2.2,
            spaceBetween: 16,
          },
          1300: {
            //slidesPerView: 2.5,
            spaceBetween: 40
          },
          1500: {
            //slidesPerView: 3.2,
            spaceBetween: 40
          },
          2000: {
            //slidesPerView: 4.2,
            spaceBetween: 40
          },
          2500: {
            //slidesPerView: 4.5,
            spaceBetween: 40
          },
          3000: {
            //slidesPerView: 5.2,
            spaceBetween: 40
          },
          3500: {
            //slidesPerView: 5.5,
            spaceBetween: 40
          },
          4000: {
            //slidesPerView: 6.2,
            spaceBetween: 40
          },
          4500: {
            //slidesPerView: 6.5,
            spaceBetween: 40
          },
          5000: {
            //slidesPerView: 7.2,
            spaceBetween: 40
          }
        },
      });

    this.checkLimit();
    let that = this
    swiper.on('progress', function () {
      that.checkLimit();
    });

  }

  checkLimit(){
    if($(this.selector).closest('.position-relative').find(this.nav.prevEl).hasClass(this.nav.disabledEl)){
      $(this.selector).closest('.position-relative').find(this.nav.prevLine).addClass('d-none');
    }else{
      $(this.selector).closest('.position-relative').find(this.nav.prevLine).removeClass('d-none');
    }

    if($(this.selector).closest('.position-relative').find(this.nav.nextEl).hasClass(this.nav.disabledEl)){
      $(this.selector).closest('.position-relative').find(this.nav.nextLine).addClass('d-none');
    }else{
      $(this.selector).closest('.position-relative').find(this.nav.nextLine).removeClass('d-none');
    }

    if($(this.selector).closest('.position-relative').find(this.nav.prevEl).hasClass(this.nav.disabledEl) && $(this.selector).closest('.position-relative').find(this.nav.nextEl).hasClass(this.nav.disabledEl)){
      $(this.selector).find(">:first-child").addClass('justify-content-center');
    }else{
      $(this.selector).find(">:first-child").removeClass('justify-content-center');
    }
  }
}


export { ProductSingleSlider as default };
